import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Button, Input } from '../../components/common';
import { ReactComponent as Footerlogo } from "./../../assets/svg/footerlogo.svg";
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import { Link } from "react-router-dom";
import appRoutes from "../../routes/app.routes";
import { FlashMessage } from "../../components/common";
import API_URLS from "../../utils/apiUrls";
import { openHttpRequest } from "../../utils/httpRequest";
import { useForm } from "react-hook-form";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
	},
}));

type Inputs = {
	email: string;
};

export default function CompanyFooter() {
	const classes = useStyles();
	const { register, formState: { errors }, handleSubmit, reset: resetForm } = useForm<Inputs>();
	const [loader, setLoader] = useState<boolean>(false);

	const handleSubscription = async (formdata: Inputs) => {
		setLoader(true);

		try {
			const response = await openHttpRequest().post(`${API_URLS.subscribe}`, {
				email: formdata.email.trim(),
			});

			FlashMessage(response.data?.message || "Thanks for subscribing.");
			resetForm();
		} catch (error) {
			const errorMessage = axios.isAxiosError<{ message?: string; errors?: { email?: string } }>(error)
				? error.response?.data?.errors?.email || error.response?.data?.message
				: undefined;

			FlashMessage(errorMessage || "Unable to subscribe right now. Please try again.", "error");
		} finally {
			setLoader(false);
		}
	};

	return (
		<div className="footer-container">
			<Container fixed>
				<div className={`${classes.root} footer-wrap`} >
					<Grid container spacing={3}>
						<Grid item xs={6} sm={3}>
							<div className="f-column">
								<Footerlogo />
								<ul className="social-icon">
									<li>
										<a href="https://www.facebook.com/employher/" target="_blank" rel="noreferrer" className="fb"> <FacebookIcon /> </a>
									</li>
									<li>
										<a href="https://twitter.com/employher" target="_blank" rel="noreferrer" className="tw"> <TwitterIcon /> </a>
									</li>
									<li>
										<a href="https://www.instagram.com/employherinc/" target="_blank" rel="noreferrer" className="ig"> <InstagramIcon /> </a>
									</li>
								</ul>
							</div>
						</Grid>
						<Grid item xs={6} sm={3}>
							<div className="f-column">
								{/* <h5>Menu</h5>
                      <ul>
                        <li>
                          <a href="" className="link">Demo link 1</a>
                        </li>
                        <li>
                          <a href="" className="link">Demo link 2</a>
                        </li>
                        <li>
                          <a href="" className="link">Demo link 3</a>
                        </li>
                        <li>
                          <a href="" className="link">Demo link 4</a>
                        </li>
                      </ul> */}
							</div>
						</Grid>
						<Grid item xs={6} sm={3}>
							<div className="f-column">
								{/* <h5>Features</h5>
                      <ul>
                        <li>
                          <a href="" className="link">Demo link 5</a>
                        </li>
                        <li>
                          <a href="" className="link">Demo link 6</a>
                        </li>
                        <li>
                          <a href="" className="link">Demo link 7</a>
                        </li>
                        <li>
                          <a href="" className="link">Demo link 8</a>
                        </li>
                      </ul> */}
							</div>
						</Grid>
						<Grid item xs={6} sm={3}>
							<div className="f-column">
								<h5>Newsletter</h5>
								<form onSubmit={handleSubmit(handleSubscription)}>
									<div className="">
									<Input
										type="email"
										autoComplete="email"
										externalLabel={{ label: "" }}
										placeholder="Your Email"
										validationObj={errors}
										{...register("email", {
											required: {
												value: true,
												message: "Please enter email address",
											},
											pattern: {
												value: /\S+@\S+\.\S+/,
												message: "Enter valid email address",
											},
										})}
									/>
									<Button type="submit" loading={loader}>Subscribe</Button>
									</div>
								</form>
							</div>
						</Grid>
					</Grid>
				</div>
				<div className="footer-mini">
					<div className="f-mini-left">
						<p>Copyright © 2022 employ<span>HER</span>. All Rights Reserved.</p>
					</div>
					<div className="f-mini-right">
						<Link to={appRoutes.privacyPolicy.generatePath()} className="tu-link link">Terms of Use</Link>
						<Link to={appRoutes.privacyPolicy.generatePath()} className="pp-link link">Privacy Policy</Link>
					</div>

				</div>
			</Container>
		</div>
	);
}
